import React, { FC } from 'react';
import Alert, { AlertTypes } from '@common/components/Alert/Alert';
import { FieldArrayMetaProps } from 'redux-form';

type GroupErrorProps = {
  meta: FieldArrayMetaProps;
};

export const GroupError: FC<GroupErrorProps> = ({ meta }) =>
  meta.submitFailed && meta?.error ? <Alert type={AlertTypes.Error} content={meta.error} /> : null;
